import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Input,
} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

// import { fetchTripsList, deleteTrip } from "../../../slices/thunks/tripsThunk";
import CustomPagination from "../../../Components/Common/CustomePagination";
import ConfirmModal from "../../../Components/Common/ConfirmModal";
import {
  addBookedTrip,
  deleteBookedTrip,
  editBookedTrip,
  fetchCustomersList,
  fetchSessionsList,
  fetchSuppliersList,
  fetchTripsList,
  fetchVehiclesList,
} from "../../../slices/thunks";
import BookTripModal from "../../../Modals/Trip/BookTripModal";
import ViewBookedTripModal from "../../../Modals/Trip/ViewBookedTripDetails";
import EditTripModal from "../../../Modals/Trip/EditTripModal";
import BookTripForm from "../../Forms/Transaction/BookTripForm";
import NF from "../../../assets/images/file.png";
// import ViewTripModal from "../../../Modals/Trips/ViewTripModal"; // <-- create this

const BookTrip = () => {
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearch, setDebouncedSearch] = useState("");

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [orderBy, setOrderBy] = useState("DESC");

  const [selectedTripId, setSelectedTripId] = useState(null);
  const [selectedTrip, setSelectedTrip] = useState(null);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [activeSession, setActiveSession] = useState(null);

  const toggleConfirmModal = () => setIsConfirmModalOpen(!isConfirmModalOpen);
  const toggleViewModal = () => setIsViewModalOpen(!isViewModalOpen);

  // SELECTOR
  const selectTripsState = (state) => state;

  const tripsSelector = createSelector(selectTripsState, (state) => ({
    trips: state.Trip.trips,
    loading: state.Trip.loading,
    error: state.Trip.error,
    pagination: state.Trip.pagination,
    customers: state.Customer.customers,
    vehicles: state.Vehicle.vehicles,
    sessions: state.Session.sessions,
    suppliers: state.Supplier.suppliers,
    activeSessions: state.Session.selectedSessionYear,
  }));

  const {
    trips,
    loading,
    error,
    customers,
    vehicles,
    sessions,
    suppliers,
    pagination,
    activeSessions,
  } = useSelector(tripsSelector);
  const resetSearch = () => {
    setSearchTerm("");

    setPageNo(0);
  };

  const handleOpenBookTrip = () => {
    dispatch(fetchCustomersList({ isPagination: 0 }));
    dispatch(fetchVehiclesList({ isPagination: 0 }));
    // dispatch(fetchSessionsList({ isPagination: 0, isActive: true }));
    dispatch(fetchSuppliersList({ isPagination: 0 }));

    // setIsAddModalOpen(true);
    setIsFormOpen(true);
  };

  const handeBookTrip = async (bookedTrip) => {
    await dispatch(addBookedTrip(bookedTrip));
    await dispatch(
      fetchTripsList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: orderBy,
        isPagination: 1,
        sessionId: activeSessions?.id,
      }),
    );
  };

  const openEdit = (trip) => {
    dispatch(fetchCustomersList({ isPagination: 0 }));
    dispatch(fetchVehiclesList({ isPagination: 0 }));
    // dispatch(fetchSessionsList({ isPagination: 0, isActive: true }));
    dispatch(fetchSuppliersList({ isPagination: 0 }));

    setSelectedTrip(trip);
    setIsEditOpen(true);
  };

  const handleUpdateTrip = async (updatedTrip) => {
    await dispatch(editBookedTrip(updatedTrip));
    resetSearch();
    await dispatch(
      fetchTripsList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: orderBy,
        isPagination: 1,
        sessionId: activeSessions?.id,
      }),
    );
  };

  // Delete handler
  const handleDeleteClick = (id) => {
    setSelectedTripId(id);
    setIsConfirmModalOpen(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteBookedTrip(selectedTripId));
    resetSearch();

    await dispatch(
      fetchTripsList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: orderBy,
        isPagination: 1,
        sessionId: activeSessions?.id,
      }),
    );
  };

  // Debounce search
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(t);
  }, [searchTerm]);

  // Fetch Trips
  useEffect(() => {
    dispatch(
      fetchTripsList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: orderBy,
        isPagination: 1,
        searchTerm: debounceSearch.trim(),
        sessionId: activeSessions?.id,
      }),
    );
  }, [dispatch, pageNo, pageSize, activeSessions, debounceSearch, orderBy]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
                  <h4 className="card-title mb-0">
                    {isFormOpen
                      ? "Book Daily Trip"
                      : isEditOpen
                        ? "Edit Trip"
                        : "Trip List"}
                  </h4>

                  {!isFormOpen && !isEditOpen ? (
                    <Button
                      color="primary"
                      className="btn btn-sm"
                      onClick={handleOpenBookTrip}
                    >
                      <i className="ri-add-line align-bottom me-1"></i>
                      Book Trip
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => {
                        setIsFormOpen(false);
                        setIsEditOpen(false);
                        setSelectedTrip(null);
                      }}
                    >
                      <i className="ri-arrow-left-line align-bottom me-1"></i>
                      Back to Listing
                    </Button>
                  )}
                </div>
              </CardHeader>

              <CardBody>
                {isFormOpen ? (
                  <BookTripForm
                    customers={customers}
                    vehicles={vehicles}
                    sessions={activeSessions}
                    suppliers={suppliers}
                    onSubmit={async (bookedTrip) => {
                      await handeBookTrip(bookedTrip);
                      setIsFormOpen(false);
                    }}
                    // onCloseForm={setIsFormOpen(false)}
                  />
                ) : (
                  <>
                    {/* Search */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="search-box w-25">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search trips..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPageNo(0);
                          }}
                        />
                      </div>

                      {/* <div>
                        <button 
                          onClick={() => setOrderBy(orderBy === "ASC" ? "DESC" : "ASC")}
                        >
                          {orderBy === "ASC" ? "Sort Desc" : "Sort Asc"}
                        </button>
                      </div> */}
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>Sr No</th>
                            <th>Trip No</th>
                            <th>Invoice No</th>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Supplier</th>
                            <th>Vehicle</th>
                            <th>Trip Type</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {loading ? (
                            [...Array(pageSize)].map((_, i) => (
                              <tr key={i}>
                                {[...Array(9)].map((_, j) => (
                                  <td key={j}>
                                    <Skeleton height={15} width={80} />
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : error ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-center text-danger"
                              >
                                {error}
                              </td>
                            </tr>
                          ) : trips?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-center text-muted"
                              >
                                <img
                                  src={NF}
                                  alt="No File"
                                  style={{ width: "500px", marginTop: "10px" }}
                                />
                              </td>
                            </tr>
                          ) : (
                            trips?.map((trip, index) => (
                              <tr
                                key={trip.id}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setSelectedTrip(trip);
                                  toggleViewModal();
                                }}
                              >
                                <td>{pageNo * pageSize + index + 1}</td>
                                <td>{trip?.tripNo || "-"}</td>
                                <td>{trip?.tripInvoiceNo || "-"}</td>
                                <td>{trip?.tripDate || "-"}</td>
                                <td>{trip?.customerName || "-"}</td>
                                <td>{trip?.suppliersName || "-"}</td>
                                <td>{trip?.vehicleNo || "-"}</td>
                                <td>{trip?.tripType || "-"}</td>
                                <td>{trip?.amount || "-"}</td>

                                <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-success btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openEdit(trip);
                                      }}
                                    >
                                      <i className="ri-edit-2-line"></i>
                                    </button>
                                    {/* DELETE */}
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteClick(trip.id);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="mt-3">
                      <CustomPagination
                        currentPage={pagination?.currentPage}
                        totalPages={pagination?.totalPages}
                        onPageChange={(page) => setPageNo(page)}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        setPageNo={setPageNo}
                      />
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* {isFormOpen && (
        <BookTripForm
          customers={customers}
          vehicles={vehicles}
          sessions={sessions}
          suppliers={suppliers}
          onSubmit={handeBookTrip}
        />
      )} */}

      {/* <BookTripModal
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen(false)}
        customers={customers}
        vehicles={vehicles}
        sessions={sessions}
        suppliers={suppliers}
        onSubmit={handeBookTrip}
      /> */}

      {/* DELETE CONFIRMATION */}
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        toggle={toggleConfirmModal}
        title="Delete Trip"
        message="Are you sure you want to delete this trip?"
        onConfirm={confirmDelete}
      />

      {/* VIEW TRIP DETAILS */}
      <ViewBookedTripModal
        show={isViewModalOpen}
        toggle={toggleViewModal}
        trip={selectedTrip}
      />

      <EditTripModal
        isOpen={isEditOpen}
        toggle={() => setIsEditOpen(false)}
        customers={customers}
        vehicles={vehicles}
        sessions={activeSessions}
        suppliers={suppliers}
        trip={selectedTrip}
        onSubmit={handleUpdateTrip}
      />
    </div>
  );
};

export default BookTrip;
